import { defaultTheme } from "react-admin";
import merge from "lodash/merge";

export const myTheme = merge({}, defaultTheme, {
  palette: {
    primary: {
      main: "#67ad11",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#74b622",
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&.RaDatagrid-cell, &.RaDatagrid-headerCell": {
            minWidth: "8em",
          },
        },
      },
    },
    RaListToolbar: {
      styleOverrides: {
        root: {
          justifyContent: "flex-start",
        },
      },
    },
    RaFilterForm: {
      styleOverrides: {
        root: {
          flex: "0 1 auto !important",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "flex-start",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: any }) => ({
          ...(ownerState.fullWidth ? {} : { width: "16em", maxWidth: "16em" }),
        }),
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          "& > .RaSidebar-fixed": {
            // HACK 本来なら上記のような記述で直接指定で済むはずだが、内部的に設定できないようなので、子要素としての指定としている
            width: "inherit !important",
            maxWidth: "inherit !important",
            overflowX: "hidden",
          },
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        // HACK React-Admin v4よりマウスホイールで数値入力が変化してしまうが、米市場のデータ特性上数値の入力は重要な要素で、間違って数値が変わってしまう要因になるため、マウスホイールでの数値の変動を抑制
        // https://water-cell.backlog.com/view/AN_KOME-1515
        onWheel: (e: any) => {
          if (e.target.type === "number") {
            e.target.blur();
          }
        },
      },
    },
    RaSkipNavigationButton: {
      styleOverrides: {
        root: {
          display: "none !important",
        },
      },
    },
  },
});
